import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Category } from '@sda/interfaces/category';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const loadCategories = createAction<never>(`${Reducers.CATEGORIES}/loadCategories`);

export const categoryAdapter = createEntityAdapter<Category & FetchDataType>({
  sortComparer: (a, b) => a.sortOrder - b.sortOrder,
});

const categoriesSlice = createSlice({
  initialState: categoryAdapter.getInitialState(),
  name: Reducers.CATEGORIES,
  reducers: {
    ...extractSharedActions(categoryAdapter),
  },
});

export default categoriesSlice.reducer;
